import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import {OFFER_LABELS} from '../../../utils/upselling';
import Modal from '../../../components/Modal';

export const CaseBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  column-gap: 5%;

  .paragraph {
    border-bottom: 1px solid #e6e8ec;
    padding: 50px 0 50px 0;
  }

  @media (max-width: ${device.laptop}) {
    flex-direction: column;
    align-items: center;
    .paragraph {
      padding: 30px 0 30px 0;
      margin: 0 auto;

      &:nth-last-child(1) {
        border-bottom: 0;
      }
    }
  }
`;

export const Image = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 25px;
  height: 570px;
  max-width: 570px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow-x: hidden;

  @media (max-width: ${device.laptop}) {
    border-radius: 20px;
    height: 330px;
    align-self: center;
    width: 100%;
  }
`;

export const RoundBadges = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  font-size: 16px;
  color: #777e90;

  @media (max-width: ${device.laptop}) {
    display: flex;
    flex-direction: column;
    font-size: 18px;
  }
`;

export const Price = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .oldprice {
    color: #b1b5c3;
    font-weight: 400;
    font-size: 32px;
    text-decoration: line-through;
    letter-spacing: -0.32px;
    display: flex;
    align-items: center;
  }

  @media (max-width: ${device.mobileM}) {
    justify-content: space-between;

    .oldprice,
    .newprice {
      font-size: 36px;
    }

    .textPrice {
      font-size: 18px;
      white-space: nowrap;
    }
  }
`;

export const PriceButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 13px 0;
  gap: 50px;

  @media (max-width: ${device.mobileM}) {
    gap: 10px;
    flex-direction: column;
    padding: 20px 0 0 0;
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;

  .scheduleDate {
    color: #23262f;
    font-weight: 500;
    font-size: 16px;
  }

  .scheduleTime {
    color: #777e90;
    font-weight: 400;
    font-size: 12px;
  }

  .subTitle {
    color: #23262f;
    font-weight: 500;
    font-size: 32px;
    padding-bottom: 30px;
  }

  .text18 {
    color: #777e91;
    font-weight: 400;
    font-size: 18px;
    display: flex;
  }

  @media (max-width: ${device.laptop}) {
    align-content: center;

    .subTitle {
      font-size: 24px;
    }

    .scheduleDate {
      font-size: 18px;
    }

    .scheduleTime {
      font-size: 14px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const OrderRow = styled(Row)`
  justify-content: space-between;
  border-bottom: 1px solid #e6e8ec;
  padding: 20px 0;

  &:nth-child(6) {
    border-bottom: 0;
  }
  .rowName {
    font-size: 19px;
    font-weight: 600;
  }

  .rowValue {
    display: flex;
    align-items: center;

    .newPrice {
      font-size: 20px;
      font-weight: 700;
    }

    .unitType {
      color: #b1b5c4;
      font-weight: 400;
      font-size: 16px;
      text-transform: lowercase;
    }
  }
`;

export const TotalPriceRow = styled(OrderRow)`
  background-color: #e5e5eb;
  border-radius: 24px;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 50px;
  margin-bottom: 50px;

  .rowName {
    font-size: 19px;
    font-weight: 600;
  }

  .priceValue {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: -0.32px;
  }
`;

export const OrderCol = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e6e8ec;
  padding: 20px 0;

  .rowName {
    font-size: 19px;
    font-weight: 600;
  }
`;

export const ExperienceProperty = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const ModalSuccessfullyRequested = styled(Modal)`
  display: flex;
  align-items: center;
  gap: 20px;

  &.buttonSuccessRequestedModal {
    margin: auto;
    justify-content: center;
  }
`;

export const Label = styled.div<{value: OFFER_LABELS}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: 42%;
  right: 0;
  box-shadow: -2px 4px 5px #00000029;

  ${props => {
    switch (props.value) {
      case OFFER_LABELS.selected: {
        return css`
          background-color: #2148ff;
        `;
      }
      case OFFER_LABELS.requested: {
        return css`
          background-color: #f8c619;
        `;
      }
      default: {
        return '';
      }
    }
  }};
`;

export const LargeLabel = styled(Label)``;
